import { _, moment, Radio, Backbone, CountryList } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import { Backform, Biscuit, Notification } from "../../utils";

import User from "../../models/User";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import OffCanvasUsersFormTpl from "../../templates/users/OffCanvasEmailFormTpl.html";

export default InboomaBaseView.extend({
  template: OffCanvasUsersFormTpl,
  parentView: "users", // For routing back
  el: "#inb-off-canvas",

  ui: {
    userAddOrderBtn: "#user-add-order-btn",
    resetPasswordBtn: ".button-reset-password",
    changeUserRoleSelect: ".form-control",
  },

  events: {
    "click @ui.userAddOrderBtn": "_addOrderToUser",
  },

  behaviors: [
    {
      behaviorClass: OffCanvasBehavior,
      openCanvas: (view) => {
        if (typeof view.options.openCanvas != "undefined") {
          return view.options.openCanvas;
        }
        return true;
      },
      beforeSave: (model) => {
        // As you see, this is a hacky way of doin' things
        // Instead, use approach from ReservationsList and create
        // a clone consisting only of whitelisted attributes
        delete model.attributes.api_token;
        delete model.attributes.activation_date;
        delete model.attributes.secret;
        delete model.attributes.secret_verified;
        delete model.attributes.tos_date;
        delete model.attributes.password;
        delete model.attributes._new_password_1;
        delete model.attributes._new_password_2;
        delete model.attributes.clients;
        delete model.attributes.is_superuser;
        delete model.attributes._listItemContent;
        delete model.attributes.user_locations;

        if (
          model.get("username") === undefined ||
          model.get("username") === null ||
          model.get("username") === ""
        ) {
          delete model.attributes.username;
        }

        if (model.get("id") === null) {
          model.set("client_id", Number(Biscuit.get("user.client_id")));
        }

        // transform email settings to model
        _.each(model.get("user_email_settings"), function (setting) {
          if (setting.template_type == "Order") {
            if (model.get("booking_info_subscribed") === true) {
              setting.subscribed = true;
            } else if (model.get("booking_info_subscribed") === false) {
              setting.subscribed = false;
            }
          }
          if (setting.template_type == "DefectResource") {
            if (model.get("damage_report_subscribed") === true) {
              setting.subscribed = true;
            } else if (model.get("damage_report_subscribed") === false) {
              setting.subscribed = false;
            }
          }
          if (
            setting.template_type == "GroupList" &&
            Biscuit.get("client.isVehicleOwner") === "true"
          ) {
            if (model.get("group_list_subscribed") === true) {
              setting.subscribed = true;
            } else if (model.get("group_list_subscribed") === false) {
              setting.subscribed = false;
            }
          }
          if (setting.template_type == "BatteryLockValue") {
            if (model.get("battery_lock_value_subscribed") === true) {
              setting.subscribed = true;
            } else if (model.get("battery_lock_value_subscribed") === false) {
              setting.subscribed = false;
            }
          }
          if (setting.template_type == "TaskChanged") {
            if (model.get("task_changed_subscribed") === true) {
              setting.subscribed = true;
            } else if (model.get("task_changed_subscribed") === false) {
              setting.subscribed = false;
            }
          }
          if (setting.template_type == "TaskCreated") {
            if (model.get("task_created_subscribed") === true) {
              setting.subscribed = true;
            } else if (model.get("task_created_subscribed") === false) {
              setting.subscribed = false;
            }
          }
          if (setting.template_type == "TaskComment") {
            if (model.get("task_comment_subscribed") === true) {
              setting.subscribed = true;
            } else if (model.get("task_comment_subscribed") === false) {
              setting.subscribed = false;
            }
          }
        });
        delete model.attributes.booking_info_subscribed; // remove "dummy" value in model
        delete model.attributes.damage_report_subscribed; // remove "dummy" value in model
        delete model.attributes.group_list;
        delete model.attributes.battery_lock_value;
        delete model.attributes.task_created;
        delete model.attributes.task_changed;
        delete model.attributes.task_comment;
      },
      afterSaveSuccess: (model, view, response) => {
        // POST /users/userRegistration returns data[0]
        // POST /users returns data

        if (typeof response.data[0] != "undefined") {
          model = new User(response.data[0]);
        } else {
          model = new User(model.toJSON());
        }

        if (model.get("created") == "" || _.isNull(model.get("created"))) {
          model.set("created", moment().toISOString());
        }

        if (model.get("role") == "manager" || model.get("role") == "admin") {
          // Route directly to staffs page
          view.parentView += "/staff";
        }

        view.parentView += "/staff";

        if (typeof view.collection !== "undefined") {
          // If we come here from "My profile settings" link,
          // we may not have yet a global collection
          // e.g. when logged in user has role "user"
          view.collection.set(model, { add: true, merge: true, remove: false });
        }

        let msg =
          view.t(view.isNew ? "saved_${a}" : "updated_${a}", { a: view.t("user") }, "capital") +
          ' "' +
          model.get("username") +
          '". ' +
          (view.isNew ? view.t("user_registration_mail_sent") : "");
        if (
          model.get("email") === undefined ||
          model.get("email") === null ||
          model.get("email") == ""
        ) {
          msg =
            view.t(view.isNew ? "saved_${a}" : "updated_${a}", { a: view.t("user") }, "capital") +
            ".";
        }
        new Notification({
          message: msg,
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-check",
        });

        // if model.get('role') == manager || admin
        // Backbone.history.navigate('users/staff');
      },
      afterSaveError: (model, view, response) => {
        view.$el.find(".rollingLoader").fadeOut("fast");

        if (
          typeof response.data !== "undefined" &&
          typeof response.responseJSON.data.errors !== "undefined"
        ) {
          if (response.success === false) {
            _.each(response.responseJSON.data.errors, (type, code) => {
              switch (code) {
                case "email":
                  // if (typeof type._isUnique !== 'undefined) {
                  view._throwMailUniqueError();
                  break;

                case "username":
                  if (typeof type._isUnique !== "undefined") {
                    view._throwUsernameUniqueError();
                  } else if (typeof type.regex !== "undefined") {
                    view._throwUsernameMinimumError();
                  }
                  break;
              }
            });
          }
        } else {
          new Notification({
            message: view.t("request_error"),
            duration: 5000,
            type: "warning",
            closeable: true,
            icon: "fi fi-x",
          });
        }
      },
    },
  ],

  initialize() {
    this.isNew = this.model.get("id") == "";

    const that = this;

    if (this.model.get("id") == "") {
      // Inherit default language from its client
      this.model.set("lang", Biscuit.get("user.lang"));

      if (Biscuit.get("client.country") !== "") {
        this.model.attributes.user_addresses.push({ country: Biscuit.get("client.country") });
      }
    }

    // prepare e-mail settings for staff
    if (
      this.model.get("role") == "manager-location" ||
      this.model.get("role") == "manager" ||
      this.model.get("role") == "admin" ||
      this.model.get("role") == "mediator"
    ) {
      let _mailSettings = this.model.get("user_email_settings");
      this.model.attributes.user_email_settings = []; // clear email-settings

      _.each(_mailSettings, function (setting) {
        if (setting.template_type == "Order") {
          that.model.set("booking_info_subscribed", setting.subscribed); // put existing setting into temp variable for backform
          that.model.attributes.user_email_settings.push(setting); // push setting back into model
        } else if (setting.template_type == "DefectResource") {
          that.model.set("damage_report_subscribed", setting.subscribed); // put existing setting into temp variable for backform
          that.model.attributes.user_email_settings.push(setting); // push setting back into model
        } else if (
          setting.template_type == "GroupList" &&
          Biscuit.get("client.isVehicleOwner") === "true"
        ) {
          that.model.set("group_list_subscribed", setting.subscribed); // put existing setting into temp variable for backform
          that.model.attributes.user_email_settings.push(setting); // push setting back into model
        } else if (setting.template_type == "BatteryLockValue") {
          that.model.set("battery_lock_value_subscribed", setting.subscribed); // put existing setting into temp variable for backform
          that.model.attributes.user_email_settings.push(setting); // push setting back into model
        } else if (setting.template_type == "TaskCreated") {
          that.model.set("task_created_subscribed", setting.subscribed); // put existing setting into temp variable for backform
          that.model.attributes.user_email_settings.push(setting); // push setting back into model
        } else if (setting.template_type == "TaskChanged") {
          that.model.set("task_changed_subscribed", setting.subscribed); // put existing setting into temp variable for backform
          that.model.attributes.user_email_settings.push(setting); // push setting back into model
        } else if (setting.template_type == "TaskComment") {
          that.model.set("task_comment_subscribed", setting.subscribed); // put existing setting into temp variable for backform
          that.model.attributes.user_email_settings.push(setting); // push setting back into model
        }
      });
      if (typeof this.model.get("booking_info_subscribed") == "undefined") {
        // set default value if setting not set yet
        this.model.attributes.user_email_settings.push({
          template_type: "Order",
          subscribed: this.model.get("role") == "manager-location",
        });
      }
      if (typeof this.model.get("damage_report_subscribed") == "undefined") {
        // set default value if setting not set yet
        this.model.attributes.user_email_settings.push({
          template_type: "DefectResource",
          subscribed: this.model.get("role") == "manager",
        });
      }
      if (typeof this.model.get("group_list_subscribed") == "undefined") {
        // set default value if setting not set yet
        this.model.attributes.user_email_settings.push({
          template_type: "GroupList",
          subscribed: this.model.get("role") == "manager",
        });
      }
      if (typeof this.model.get("battery_lock_value_subscribed") == "undefined") {
        // set default value if setting not set yet
        this.model.attributes.user_email_settings.push({
          template_type: "BatteryLockValue",
          subscribed: this.model.get("role") == "manager",
        });
      }
      if (typeof this.model.get("task_created_subscribed") == "undefined") {
        // set default value if setting not set yet
        this.model.attributes.user_email_settings.push({
          template_type: "TaskCreated",
          subscribed: this.model.get("role") == "manager",
        });
      }
      if (typeof this.model.get("task_changed_subscribed") == "undefined") {
        // set default value if setting not set yet
        this.model.attributes.user_email_settings.push({
          template_type: "TaskChanged",
          subscribed: this.model.get("role") == "manager",
        });
      }
      if (typeof this.model.get("task_comment_subscribed") == "undefined") {
        // set default value if setting not set yet
        this.model.attributes.user_email_settings.push({
          template_type: "TaskComment",
          subscribed: this.model.get("role") == "manager",
        });
      }
    }

    this.render();
  },

  templateContext() {
    return {
      is_own_user: Biscuit.get("user.id") === this.model.get("id"),
      created_printable: moment(this.model.get("created")),
      modified_printable: moment(this.model.get("modified")),
    };
  },

  onRender() {
    const that = this;

    let user_roles = [
      { label: this.t("role_user", null, "capital"), value: "user" },
      { label: this.t("role_manager", null, "capital"), value: "manager" },
      { label: this.t("role_garage-staff", null, "capital"), value: "garage-staff" },
      { label: this.t("role_manager-location", null, "capital"), value: "manager-location" },
      { label: this.t("role_mediator", null, "capital"), value: "mediator" },
      // { label : this.t('role_guide',null,'capital'), value : 'guide'},
      { label: this.t("role_admin", null, "capital"), value: "admin" },
    ];

    if (Biscuit.get("user.role") == "admin") {
      user_roles.push({ label: this.t("admin", null, "capital"), value: "admin" });
    }

    if (Biscuit.get("user.client_id") == 7) {
      user_roles.push({
        label: this.t("role_manager-location", null, "capital"),
        value: "manager-location",
      });
    }

    let fields = [
      {
        name: "username",
        label: this.t("username", null, "capital"),
        control: "input",
        helpMessage: this.model.get("username") == "" ? this.t("no_special_char_allowed") : "",
        required: true,
        disabled:
          this.model.get("id") != "" &&
          this.model.get("username") != "" &&
          this.model.get("username") != "undefined" &&
          this.model.get("username") != null,
        size: {
          large: "5",
        },
      },
      {
        name: "role",
        label: this.t("user_role", null, "capital"),
        control: "select",
        required: true,
        options: user_roles,
        disabled: true,
        size: {
          large: "5",
        },
      },
      {
        control: "spacer",
      },
    ];

    if (
      this.model.get("role") == "manager-location" ||
      this.model.get("role") == "manager" ||
      this.model.get("role") == "admin" ||
      this.model.get("role") == "mediator" ||
      this.model.get("role") == "garage-staff"
    ) {
      // show settings for receiving emails with booking info
      if (this.model.get("role") != "garage-staff") {
        fields.push({
          name: "booking_info_subscribed",
          label: that.t("email_setting_get_booking_info"),
          control: "boolean",
          extraTopClasses: ["label-float-left top-space"],
        });
      }
      fields.push(
        {
          name: "damage_report_subscribed",
          label: that.t("email_setting_get_damage_report"),
          control: "boolean",
          extraTopClasses: ["label-float-left top-space"],
        },
        {
          name: "battery_lock_value_subscribed",
          label: that.t("email_setting_get_battery_lock_value"),
          control: "boolean",
          extraTopClasses: ["label-float-left top-space"],
        },
        {
          name: "task_created_subscribed",
          label: that.t("email_setting_get_task_created"),
          control: "boolean",
          extraTopClasses: ["label-float-left top-space"],
        },
        {
          name: "task_changed_subscribed",
          label: that.t("email_setting_get_task_changed"),
          control: "boolean",
          extraTopClasses: ["label-float-left top-space"],
        },
        {
          name: "task_comment_subscribed",
          label: that.t("email_setting_get_task_comment"),
          control: "boolean",
          extraTopClasses: ["label-float-left top-space"],
        },
      );
      if (
        Biscuit.get("client.isVehicleOwner") === "true" &&
        this.model.get("role") != "garage-staff"
      ) {
        fields.push({
          name: "group_list_subscribed",
          label: that.t("email_setting_get_group_list"),
          control: "boolean",
          extraTopClasses: ["label-float-left top-space"],
        });
      }
    }

    this.form = new Backform.Form({
      el: that.$el.find("form"),
      model: this.model,
      fields: fields,
      events: {
        'keypress input[name="username"]'(e) {
          // Do NOT allow special chars || space
          // BUT allow Umlaut
          let k = e.which;
          return (
            (k > 64 && k < 91) ||
            (k > 96 && k < 123) ||
            k == 8 ||
            (k >= 48 && k <= 57) ||
            k == 0 ||
            k == 186 ||
            k == 192 ||
            k == 222 ||
            k == 228 ||
            k == 252 ||
            k == 246
          );
        },
      },
    }).render();

    that.$el.find("form").removeClass("row");
    // Take care that RBAC-methods are executed:
    this.onDomRefresh(this);
  },
});
